import { registerPlugin } from '@capacitor/core';
import type { LynxAdvertiserPlugin } from './advertiserDefinitions';
import { getSimPhoneHost } from './simPhone';

const simHost = getSimPhoneHost();

/** Typed Capacitor bridge for LynxAdvertiser (BLE scan/advertise — future D3 Swift plugin). On a sim phone, simAdvertiser.ts. */
export const LynxAdvertiser = registerPlugin<LynxAdvertiserPlugin>(
  'LynxAdvertiser',
  simHost
    ? { web: () => import('./simAdvertiser').then((m) => new m.SimAdvertiserPlugin(simHost)) }
    : {},
);
